import { serialize } from '@/@core/libs/serialize/util'
import Http from './http'

export const DEFAULT_PIXEL_GRANT_SENDER_NAME = 'Mundo Gamer Network'

export const grantList = (params = '') => Http.get(`/wall-pixel-grants${serialize(params)}`)
export const grantCreate = (params = '') => Http.post('/wall-pixel-grants', params)
export const grantResend = (id) => Http.post(`/wall-pixel-grants/${id}/resend`)
export const grantCancel = (id) => Http.post(`/wall-pixel-grants/${id}/cancel`)
export const grantRecipientsStatus = (emails = []) => Http.get('/wall-pixel-grants/recipients-status', { params: { emails } })

// Single entry point for granting pixels to a recipient by email — keeps the
// required fields (from_name) consistent across every UI that sends pixels.
export const sendPixelGrant = ({ recipientEmail, recipientName, pixelCount = 1, message = '', fromName = DEFAULT_PIXEL_GRANT_SENDER_NAME }) => grantCreate({
	recipient_email: recipientEmail,
	recipient_name: recipientName,
	pixel_count: pixelCount,
	message,
	from_name: fromName,
})
